import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Metamodel Definition of the Example Language",
description: "Review the complete AST for a simple language that pairs expressions with declared types. Learn how TypeUsage, TypeRef, TypeDecl, GenericType, and UnitOfMeasurement model generic types and units of measurement.",
tags: [ "Freon", "metamodel", "AST", "TypeUsage", "TypeRef", "TypeDecl", "GenericType", "UnitOfMeasurement", "GenericKind", "UnitKind", "PredefinedType", "expressions", "literals", "typer", "example language"] ,
modifiedTime: "2025-11-07T17:20:18.642Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};